__turbopack_context__.v({
  "dropdown": "mobile-nav-menu-module-scss-module__gC_zoq__dropdown",
  "secondary-link": "mobile-nav-menu-module-scss-module__gC_zoq__secondary-link",
});
